import React from "react";

import Grid from "@material-ui/core/Grid";

import InputQuestion from "../../../../question/InputQuestion";
import FormLabelElement from "../../../../formElement/LabelFormElement/LabelFormElement";
import RadioQuestion from "../../../../question/RadioQuestion";
import DateQuestion from "../../../../question/DateQuestion/DateQuestion";
import {INTERVIEW_TYPE_CONTINUE_OPTION_VALUE} from "../../../../../../../constants";

const ProtocolConversationParticipants = (props) => {
  const {
    classes,
    onAnswerChange,
    dataService,
    interviewOtherPeoplesInput,
    interviewDateType,
    interviewRepeatedDate,
    interviewBrokerInput,
    interviewCustomerInput,
    interviewAccountHolder1Input,
    interviewAccountHolder2Input,
  } = props;

  const holders = [interviewAccountHolder1Input, interviewAccountHolder2Input].filter(q => !q._ignore);

  return (
    <>
      <Grid item xs={12}>
        <Grid container spacing={dataService.isNewDesign ? 2 : 1}>
          {!dataService.isNewDesign && (
            <Grid item xs={12}>
              <FormLabelElement label={"Gesprächsteilnehmer"} required={true} customClasses={{labelRoot: 'bold'}} style={{margin: 0, padding: 0, marginTop: 16}}/>
            </Grid>
          )}
          <Grid item xs={12}>
            <Grid container direction={dataService.isNewDesign ? 'row': 'column'} spacing={dataService.isNewDesign ? 2 : undefined}>
              <Grid item xs={12} md={dataService.isNewDesign ? 6 : 4}>
                <InputQuestion
                  question={interviewBrokerInput}
                  onAnswerChange={onAnswerChange}
                />
              </Grid>
              {dataService.useMembers ?
                holders.map(q => (
                  <Grid item xs={12} md={dataService.isNewDesign ? 6 : 4} key={q.uid}>
                    <InputQuestion
                      question={q}
                      onAnswerChange={onAnswerChange}
                    />
                  </Grid>
                )) :
                <Grid item xs={12} md={dataService.isNewDesign ? 6 : 4}>
                  <InputQuestion
                    question={interviewCustomerInput}
                    onAnswerChange={onAnswerChange}
                  />
                </Grid>
              }
            </Grid>
          </Grid>
          <Grid item xs={12} md={dataService.isNewDesign ? 12 : 8}>
            <InputQuestion
              question={interviewOtherPeoplesInput}
              onAnswerChange={onAnswerChange}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Grid container direction={dataService.isNewDesign ? 'column' : undefined} alignItems={dataService.isNewDesign ? 'center' : undefined} spacing={dataService.isNewDesign ? 3 : undefined}>
          <Grid item xs={6} md={4} className={classes.checkboRegularContainer}>
            <RadioQuestion
              useCards={dataService.isNewDesign}
              question={interviewDateType}
              onAnswerChange={onAnswerChange}
            />
          </Grid>
          {(!dataService.isNewDesign || interviewDateType.answer == INTERVIEW_TYPE_CONTINUE_OPTION_VALUE) && (
            <Grid item xs={6} md={4} lg={dataService.isNewDesign ? 4 : 3} style={{display: 'flex', alignItems: 'flex-end', width: dataService.isNewDesign ? '100%' : undefined}}>
              <DateQuestion
                question={interviewRepeatedDate}
                onAnswerChange={onAnswerChange}
              />
            </Grid>
          )}
        </Grid>
      </Grid>
    </>
  )
};

export default ProtocolConversationParticipants